import { useTranslation } from '@/i18n';
import { SidePanelFormLayout } from '@/components/layout';
import { LabelInput } from '@/components/ui/inputs/LabelInput';
import type { RecalculoProcessDetail } from '@/api/domains/recalculation';


interface RecalculoDetailPanelProps {
  processData: RecalculoProcessDetail;
}

export const RecalculoDetailPanel: React.FC<RecalculoDetailPanelProps> = ({ processData }) => {
  const { t: translate } = useTranslation();

  return (
    <SidePanelFormLayout data-testid="recalculo-detail-panel">
      <SidePanelFormLayout.Fields>
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.processId')}
          value={String(processData.processId)}
          disabled
          readOnly
          data-testid="recalculo-detail-process-id"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.cutYear')}
          value={String(processData.cutYear)}
          disabled
          readOnly
          data-testid="recalculo-detail-cut-year"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.cutMonth')}
          value={processData.cutMonth}
          disabled
          readOnly
          data-testid="recalculo-detail-cut-month"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.cutDescription')}
          value={processData.cutDescription}
          disabled
          readOnly
          data-testid="recalculo-detail-cut-description"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.processedCompanies')}
          value={processData.processedCompanies}
          disabled
          readOnly
          data-testid="recalculo-detail-processed-companies"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.totalEmployees')}
          value={String(processData.totalEmployees)}
          disabled
          readOnly
          data-testid="recalculo-detail-total-employees"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.processedEmployees')}
          value={String(processData.processedEmployees)}
          disabled
          readOnly
          data-testid="recalculo-detail-processed-employees"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.executionDate')}
          value={processData.executionDate}
          disabled
          readOnly
          data-testid="recalculo-detail-execution-date"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.completionDate')}
          value={processData.completionDate ?? ''}
          disabled
          readOnly
          data-testid="recalculo-detail-completion-date"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.executedBy')}
          value={processData.executedBy}
          disabled
          readOnly
          data-testid="recalculo-detail-executed-by"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.status')}
          value={processData.status}
          disabled
          readOnly
          data-testid="recalculo-detail-status"
        />
        <LabelInput
          label={translate('attendance:recalculo.detalleProceso.fields.stoppedBy')}
          value={processData.stoppedBy ?? ''}
          disabled
          readOnly
          data-testid="recalculo-detail-stopped-by"
        />
      </SidePanelFormLayout.Fields>
    </SidePanelFormLayout>
  );
};

export default RecalculoDetailPanel;
